export default {
  courierPropRecord: '/prop/client/courierPropRecord'
}
